import AbstractView from "@/app/pixi/views/AbstractView";
import PixiApp from "@/app/pixi/PixiApp";
import {Container, Graphics, Sprite} from "pixi.js";
import CHAPTERS_DATA from "@/assets/data/chapters";

export default class BackgroundView extends AbstractView {

    constructor() {
        super({
            name: "Background"
        })
        this._originalWidth = 0;
        this._originalHeight = 0;
    }

    async build() {
        this._currentArtistId = 0;
        this._buildMask();
        await this._buildImage();
        this.resized({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }

    _buildMask() {
        this.maskContainer = new Container();
        this.maskContainer.name = "MaskContainer";
        this.maskGraph = new Graphics();
        this.maskContainer.addChild(this.maskGraph);
        this.addChild(this.maskContainer);
    }

    async _buildImage() {
        const {loader} = PixiApp;
        await loader.load();
        const resource = loader.resources[this._currentResource];
        this.image = new Sprite(resource.texture);
        this.image.mask = this.maskGraph;
        this.image.anchor.set(0.5, 0.5);
        this.addChild(this.image)
    }

    resized({width, height}) {
        this._resizeMask(width, height);
        this._resizeImage(width, height);
    }

    _resizeMask(w, h) {
        this.maskContainer.position.set(w / 2, h / 2);
        this.maskContainer.pivot.set(0.5, 0.5);
        this.maskGraph.clear();
        this.maskGraph.drawRect(-(w / 2), -(h / 2), w, h);
    }

    _resizeImage(w, h) {
        if (h > w) return;

        this.image.position.set(w / 2, h / 2)
        var containerWidth = w;
        var containerHeight = h;
        const {image} = this;

        var imageRatio = this.image.width / this.image.height;
        var containerRatio = containerWidth / containerHeight;

        if (containerRatio > imageRatio) {
            image.height = image.height / (image.width / containerWidth);
            image.width = containerWidth;
        } else {
            image.width = image.width / (image.height / containerHeight);
            image.height = containerHeight;
        }

        this._originalWidth = image.width;
        this._originalHeight = image.height;
    }

    get _currentResource() {
        return CHAPTERS_DATA[this._currentArtistId].videoCover;
    }

    setCurrentResource(id) {
        this._currentArtistId = id;
        const {loader} = PixiApp;
        const resource = loader.resources[this._currentResource];

        this.image.texture = resource.texture;
    }

    openMask() {
        TweenMax.to(this.maskGraph.scale, 0.2, {
            x: 0.45,
            y: 0.45,
            ease: Sine.easeOut,
            onComplete: () => {
                const time = 0.5;
                TweenMax.to(this, time, {alpha: 1.0, ease: Expo.easeOut});
                TweenMax.to(this.maskGraph.scale, time, {x: 1.0, y: 1.0, ease: Expo.easeOut});

                const {_originalWidth, _originalHeight} = this;
                TweenMax.to(this.image, time - 0.2, {
                    width: _originalWidth,
                    height: _originalHeight,
                    ease: Expo.easeOut
                });
            }
        });
    }

    closeMask() {
        const delay = 1;
        const time = 0.5;
        const maskScale = 0.6;

        // Container
        TweenMax.to(this, time, {delay, alpha: 0.5, ease: Power3.easeOut});

        // Mask
        TweenMax.to(this.maskGraph.scale, time, {
            delay: delay,
            x: maskScale,
            y: maskScale,
            ease: Expo.easeOut
        });

        // Image
        const imageScale = 0.8;
        const {width, height} = this.image;
        const scaledWidth = width * imageScale;
        const scaledHeight = height * imageScale;
        TweenMax.to(this.image, time, {delay, width: scaledWidth, height: scaledHeight, ease: Expo.easeOut});

    }

    onHold() {
        const time = 0.4;

        // Mask
        TweenMax.to(this.maskGraph.scale, time, {x: 0.6, y: 0, delay: 0.1, ease: Cubic.easeInOut});

        // Image
        const {_originalWidth, _originalHeight} = this;
        TweenMax.to(this.image, time, {
            width: _originalWidth * 1.2,
            height: _originalHeight * 1.2,
            ease: Cubic.easeInOut
        });

    }

    onRelease() {
        const time = 0.6;

        // Mask
        TweenMax.to(this.maskGraph.scale, time, {x: 0.6, y: 0.6, ease: Cubic.easeInOut});

        // Image
        const {_originalWidth, _originalHeight} = this;
        TweenMax.to(this.image, time, {
            width: _originalWidth * 0.8,
            height: _originalHeight * 0.8,
            ease: Cubic.easeInOut
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/pixi/views/BackgroundView.js